'use es6';

import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import getEarlyRequesterResultPromise from 'ContentEditorUI/earlyRequester/getEarlyRequesterResultPromise';
const fetch = () => {
  return getEarlyRequesterResultPromise(`initial-blogs-limit-fetch`, false) || http.get(`blog-settings/v1/blogs/${PortalIdParser.get()}/usage`);
};
export default {
  fetch
};